import React, { Component } from 'react';
import { Button, Modal } from 'semantic-ui-react';
import './PremiumDialog.css';
import '../settings/PlanAndBilling.css';
import Strings from '../../common/Strings';

class PremiumSuccessDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      successPaymentModalOpen: true,
    };
  }

  render() {
    return (
      <Modal
        centered
        size="tiny"
        open={this.state.successPaymentModalOpen}
        closeIcon
        onClose={() => {
          this.setState({ successPaymentModalOpen: false });
        }}
      >
        <div className="premium-success-modal-title">
          {Strings.BILLING.successfulPremium}
        </div>
        <div className="common-modal-root plan-and-billing-modal-danger-root">
          <div className="plan-and-billing-modal-section">
            <div className="plan-and-billing-modal-section-danger-container">
              <p className="common-modal-title plan-and-billing-modal-section-danger-title">
                {Strings.BILLING.successfulPremiumTitle}
              </p>
              <p className="common-modal-body plan-and-billing-modal-section-danger-body">
                {Strings.BILLING.successfulPremiumText}
              </p>
            </div>
          </div>
          <div className="plan-and-billing-modal-button-container">
            <Button
              className="premium-success-green-button"
              onClick={() => {
                this.setState({ successPaymentModalOpen: false });
              }}
            >
              {Strings.COMMON.ok}
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default PremiumSuccessDialog;



// WEBPACK FOOTER //
// ./src/components/dialog/PremiumSuccessDialog.js